<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="data-card fit row">
            <div class="row">
              <div
                v-for="(obj, index) in computedDatas"
                :key="index"
                :class="
                  !obj.columnsPerLine
                    ? 'col-12'
                    : 'col-md-' + 12 / obj.columnsPerLine
                "
              >
                <label>{{ obj.label }}:</label>
                {{ obj.value }}
              </div>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg full-width row">
            <span v-if="elements.length == 1" class="col-12">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'

const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'clientCarrierDetailPage',
  components: {},
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class ClientCarrierDetailPage extends Vue {
  composition= 'COMPOSICAO';
  get computedDatas () {
    this.computedData()
    return this.elements[0].inputs.filter(ci => ci.type !== this.composition)
  }

  computedData () {
    this.elements[0].inputs.forEach(input => {
      input.value = this.__formatFilterChipValue(
        input,
        this.elements[0].dadosForm
      )
    })
  }

  get inputs () {
    return this.elements[0].inputs.filter(ci => ci.type === this.composition)
  }

  __formatFilterChipValue (filtered, model) {
    switch (filtered.type.toLowerCase()) {
      case 'select':
      case 'select_ajax':
        return this.__getTypeSelectValueLabel(
          filtered.model,
          model[filtered.model]
        )
      case 'date':
        return this.__getFormatedData(filtered, model)
      case 'date_range':
        return this.__getFormatedDataRange(filtered, model)
      default:
        return model[filtered.model]
    }
  }

  __getTypeSelectValueLabel (key, value) {
    const el = this.elements[0].relacionamentos[key].find(
      rel => rel.value === value
    )
    return el ? el.label : value
  }

  __getFormatedData (filtered, model) {
    return this.date.formatDate(model[filtered.model], filtered.format)
  }

  __getFormatedDataRange (filtered, model) {
    const format = filtered.format.toUpperCase()
    return `${model[filtered.model].inicial} - ${model[filtered.model].final} `
  }
}
export default ClientCarrierDetailPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card.q-card__section, {
  height: calc(100% - 65px);
  overflow: hidden;
}

.data-card.q-card__section > div > div,  {
  padding: 5px 12px;
}
.data-card.q-card__section > div > div > label, {
  font-weight: bold;
}

.data-card.q-card__section > div > div:nth-child(odd) {
  background-color: $ice;
}

.data-card.q-card__section > div > div:nth-child(4) {
  background-color: $ice;
}
</style>
